import { useField, useFormikContext } from 'formik';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import FormikFormErrorHandler from './FormikFormErrorHandler';

type Option = {
  label: string;
  value: string | number;
  disabled?: boolean;
};

type Props = {
  field: any;
  options: Option[];
  meta: {
    touched: boolean;
    error: string;
    warning: string;
  };
  children: React.ReactNode;
  className: string;
  'data-testid'?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  placeholder: string;
  type: string;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  typeofvalues: string;
  submitonchange: boolean;
};

const FormikFormRadioGroup = (props: Props) => {
  const [field, meta, helpers] = useField(props);
  const { submitForm } = useFormikContext();
  const errorClass = `${meta.error && meta.touched ? 'error' : ''}`;
  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder;

  const { options, submitonchange } = props;
  return (
    <>
      {options.map((option: Option) => {
        // The site's global CSS hides the native radio (opacity: 0) and draws the visible
        // circle off a "input[type='radio'] + label" adjacent-sibling rule, so the input and
        // its label must be direct siblings — not nested inside each other.
        const inputId = `${props.name}-${option.value}`;
        return (
          <span
            key={option.label}
            className="radio-option"
          >
            <input
              {...props}
              {...field}
              id={inputId}
              placeholder={_placeholder}
              className={`${props.className || ''} ${errorClass}`}
              disabled={props.disabled || option?.disabled}
              type="radio"
              readOnly={props.readOnly}
              value={option.value}
              checked={field.value === option.value}
              data-testid={option.label}
              onChange={(event) => {
                const value =
                  props.typeofvalues === 'number'
                    ? parseInt(event.target.value)
                    : event.target.value;
                helpers.setValue(value);
                submitonchange && submitForm();
              }}
            />
            <label htmlFor={inputId}>
              <FormattedMessage id={option.label} />
            </label>
          </span>
        );
      })}
      <FormikFormErrorHandler
        meta={meta}
        intl={props.intl}
      />
    </>
  );
};

export default injectIntl(FormikFormRadioGroup);
